import {Component, EventEmitter, Injectable} from "@angular/core";
import {BehaviorSubject, Subscription} from "rxjs";
import {HttpFilterParam, StorageService} from "prod-shared";
import {Organization} from "../models/organization";
import {OrganizationTypeName} from "../enum/organization-type";
import {HttpClient} from "@angular/common/http";
import {CustomFilterEvent} from 'prod-grid';

@Injectable({
  providedIn: 'root'
})

export class OrganizationTreeSelect {
  ids: number[] = [];
  company: Organization;
  distributor: Organization;
  site: Organization;
  organizationTreeSelect$: BehaviorSubject<number>;
  organizationLoadedEvent$: EventEmitter<void> = new EventEmitter<void>();
  organizationTreeUpdate$: EventEmitter<void> = new EventEmitter<void>();
  gridComponent;
  formComponents: any[] = [];
  storageKey: string = 'selected-organization'
  private organizationTreeSelectSubscription$: Subscription;
  private organizationLoadedEventSubscription$: Subscription;

  constructor(private httpClient: HttpClient, private storageService: StorageService) {
    this.organizationTreeSelect$ = new BehaviorSubject<number>(Number.parseInt(this.storageService.get(this.storageKey)));
    this.organizationLoadedEvent$.subscribe(() => {
      if (this.gridComponent) {
        if (this.gridComponent.prodGridToolbarButtonsStatus) {
          Object.keys(this.gridComponent.prodGridToolbarButtonsStatus).forEach(btn => {
            this.gridComponent.prodGridToolbarButtonsStatus[btn].disabled = !this.gridComponent.roleService.hasRole(this.gridComponent.prodGridToolbarButtonsStatus[btn].role);
          });
        }

        if (this.company) {
          if (this.gridComponent.prodGridForm) {
            if (this.gridComponent.prodGridForm.extraData) {
              if (this.gridComponent.prodGridForm.extraData.currentCompany) {
                this.gridComponent.prodGridForm.extraData.currentCompany = this.company.id;
              }
            }

            if ('mercureSubscribe' in this.gridComponent) {
              this.gridComponent.mercureSubscribe();
            }
          }
        } else if (!this.company) {
          if ('mercureSubscribe' in this.gridComponent) {
            this.gridComponent.mercureService.unsubscribe();
          }
        }

        if ('setColumns' in this.gridComponent) {
          this.gridComponent.setColumns();
        }

        if (this.gridComponent.inputAction$) {
          this.gridComponent.inputAction$.emit(new CustomFilterEvent([]));
        }
      }
      if (this.formComponents.length) {
        this.formComponents.forEach(form => {
          if (form.records) {
            form.records.flush();

            if (this.company) {
              form.records.toggle(!form.isSite ? this.company : this.site ? this.site : this.company);
              form.data.records = form.records;
              if (form.initializeFormEvent$) {
                form.initializeFormEvent$.emit();
              }
            }
          }
        })
      }
    });
  }

  subscribe(): void {
    this.organizationTreeSelectSubscription$ = this.organizationTreeSelect$.subscribe(organization => {
      this.storageService.set(this.storageKey, organization);
      this.ids = [];
      if (organization > 0) {
        this.httpClient.get<{ data: Organization }>(`/api/organization/${organization}`).subscribe(response => {
          switch (response.data.organizationType.name) {
            case OrganizationTypeName.COMPANY:
              this.company = response.data;
              this.distributor = null;
              this.site = null;
              response.data.subOrganizations.forEach(site => {
                this.ids.push(site.id);
              });
              break;
            case OrganizationTypeName.DISTRIBUTOR:
              this.distributor = response.data;
              this.company = null;
              this.site = null;
              break;
            case OrganizationTypeName.SITE:
              this.company = response.data.organization;
              this.site = response.data;
              this.distributor = null;
              this.ids.push(response.data.id);
          }

          this.organizationLoadedEvent$.emit();
        });

        return;
      } else if (organization === -1) {
        this.distributor = {
          id: -1,
          name: 'No Distributor',
          organizationType: {id: 3, name: OrganizationTypeName.DISTRIBUTOR}
        };
        this.company = null;
        this.site = null;
      } else {
        this.distributor = null;
        this.company = null;
        this.site = null;
      }

      this.organizationLoadedEvent$.emit();
    });
  }

  unsubscribe(): void {
    if (this.organizationTreeSelectSubscription$) {
      this.organizationTreeSelectSubscription$.unsubscribe();
    }

    if (this.organizationLoadedEventSubscription$) {
      this.organizationLoadedEventSubscription$.unsubscribe();
    }
  }

  getHttpExtraParams(service): HttpFilterParam[] {
    if ('getOrganizationFilter' in service) {
      return service.getOrganizationFilter();
    }
    return null;
  }

  removeFormComponent(component) {
    this.formComponents = this.formComponents.filter(form => form !== component);
  }
}
